import { FC } from "react";
import { IconChevronRight } from "src/constants/icons";
import Translate from "../../../Translate/Translate";
import { LabsHintCta, LabsHintWrap } from "./AppointmentDialog.styled";

const LabsHint: FC<{ onOpenLabs: () => void }> = ({ onOpenLabs }) => {
  return (
    <LabsHintWrap>
      <h3>
        <Translate msg="appointment.detail.labsHint.title" />
      </h3>
      <p>
        <Translate msg="appointment.detail.labsHint.body" />
      </p>
      <LabsHintCta type="button" onClick={onOpenLabs}>
        <Translate msg="appointment.detail.labsHint.cta" />
        <IconChevronRight />
      </LabsHintCta>
    </LabsHintWrap>
  );
};

export default LabsHint;
